import React from 'react';
import styles from './OrderPage.module.css';
import {Section} from './Section';

interface DetailsSectionProps {
	customerName: string;
	customerInitials: string;
	deadlineLabel: string;
	deadlineValue: string;
}

export function DetailsSection({
	customerName,
	customerInitials,
	deadlineLabel,
	deadlineValue,
}: DetailsSectionProps): React.ReactElement {
	return (
		<Section title="Детали">
			<div>
				<div className="flex items-center gap-2.5 border-b border-black/10 pb-4 mb-4">
					<div className={styles.customerLogo}>{customerInitials}</div>
					<span className="text-base">{customerName}</span>
				</div>
				<div className="flex flex-col gap-1.5">
					<span className="text-black/55">{deadlineLabel}</span>
					<span className="text-base">{deadlineValue}</span>
				</div>
			</div>
		</Section>
	);
}
